<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	//Constants
	//Variables
	//Functions
	//Do
</script>

<div class="container" id="noticepage-title">
	<span id="noticetitle-text"> What's new in </span>
	<img id="noticetitle-img" src="/img/notice/NoticeTitle.png" alt="Hitithub" />
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;

		/*  */

		#noticetitle-text {
			font-family: "poppins";
			font-weight: 550;
			font-size: 1.875rem;
			color: #46474b;
		}

		#noticetitle-img {
			width: 217px;
			height: 33px;
			object-fit: contain;
			margin-left: 104px;
		}
	}
	@include DesktopSize {
		.container {
			align-items: baseline;
			flex-direction: row;
			gap: 10px;
			#noticetitle-text {
				font-size: 2.1875rem;
			}

			#noticetitle-img {
				width: 361px;
				height: 55px;
				margin-left: 0;
				object-position: 0px 12px;
			}
		}
	}
</style>
